export default __webpack_public_path__ + "static/media/challenge-end.850f90f5.mp3";